"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 TODO:
 [] support hold shift down and keep firing an event
 [] support hold ctrl donw and keep firing and event
*/

var Keyboard = function (_Component) {
  _inherits(Keyboard, _Component);

  function Keyboard(props) {
    _classCallCheck(this, Keyboard);

    var _this = _possibleConstructorReturn(this, (Keyboard.__proto__ || Object.getPrototypeOf(Keyboard)).call(this, props));

    _this.keyUp = function (event) {
      if (event.defaultPrevented) {
        return; // Do nothing if the event was already processed
      }

      var matchKey = _this.findMatchingKey(event.key);
      if (matchKey && matchKey.shouldPreventDefault) {
        event.preventDefault();
      }

      // remove property from object
      delete _this.keysMap[event.key];

      // eslint-disable-next-line
      return false; // will stop browser shortcuts
    };

    _this.keyDown = function (event) {
      if (event.defaultPrevented) {
        return; // Do nothing if the event was already processed
      }

      var matchKey = _this.findMatchingKey(event.key);

      if (matchKey) {
        matchKey.onKeyMatch(matchKey.name);
        if (matchKey.shouldPreventDefault) {
          event.preventDefault();
        }
      } else {
        _this.processCombinationKeys(event, _this.keyCodes);
      }

      // eslint-disable-next-line
      return false; // will stop browser shortcuts
    };

    _this.processEvents = function (ref) {
      if (!ref) {
        return;
      }

      _this.ref = ref;
      var children = _this.props.children;


      if (!Array.isArray(children)) {
        throw new Error("<Keyboard /> components need at least 2 children 1 of type <Key /> and 1 node");
      }

      var keys = children.filter(function (child) {
        return child.props.componentType === "Key";
      });

      if (keys.length < 1) {
        throw new Error("<Keyboard /> component needs at least 1 type of child <Key />");
      }

      var keyCodes = [];

      keys.forEach(function (key) {
        var _key$props = key.props,
            code = _key$props.code,
            onKeyMatch = _key$props.onKeyMatch,
            name = _key$props.name,
            shouldPreventDefault = _key$props.shouldPreventDefault;

        if (key.props.onKeyMatch) {
          keyCodes.push({ code: code, onKeyMatch: onKeyMatch, name: name, shouldPreventDefault: shouldPreventDefault });
        }
      });

      if (keyCodes.length) {
        _this.keyCodes = keyCodes;
      }
    };

    _this.keysMap = {};
    _this.keyCodes = [];
    return _this;
  }

  _createClass(Keyboard, [{
    key: "processCombinationKeys",
    value: function processCombinationKeys(event, keyCodes) {
      var _this2 = this;

      var keysWithCombination = keyCodes.filter(function (key) {
        return key.code.includes("+");
      });

      if (keysWithCombination.length) {
        keysWithCombination.forEach(function (keyWithCombination) {
          var keySplit = keyWithCombination.code.split("+");
          if (keySplit.includes(event.key.toLowerCase())) {
            _this2.keysMap[event.key] = true;
          }

          if (keySplit.length === Object.keys(_this2.keysMap).length) {
            keyWithCombination.onKeyMatch(keyWithCombination.name);
            _this2.keysMap = {};
          }
        });
      }
    }
  }, {
    key: "findMatchingKey",
    value: function findMatchingKey(eventKey) {
      var keyCodes = this.keyCodes.filter(function (key) {
        return key.code === eventKey.toLowerCase();
      });
      return keyCodes.length ? keyCodes[0] : null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        "div",
        {
          className: this.props.className,
          ref: function ref(element) {
            return _this3.processEvents(element);
          },
          onKeyUp: this.keyUp,
          onKeyDown: this.keyDown
        },
        this.props.children
      );
    }
  }]);

  return Keyboard;
}(_react.Component);

Keyboard.propTypes = {
  children: _propTypes.node.isRequired,
  className: _propTypes.string
};
Keyboard.defaultProps = {
  className: ""
};
exports.default = Keyboard;